import { URL, handleErrors } from "./depannageActions"
import { catchApiError, normalizeApiError } from "./apiHelpers"

export const WINBIZ_FACTURE_BEGIN = "WINBIZ_FACTURE_BEGIN"
export const WINBIZ_FACTURE_SUCCESS = "WINBIZ_FACTURE_SUCCESS"
export const WINBIZ_FACTURE_ERROR = "WINBIZ_FACTURE_ERROR"
export const WINBIZ_FACTURE_RESET = "WINBIZ_FACTURE_RESET"

export const winbizFactureBegin = () => ({ type: WINBIZ_FACTURE_BEGIN })
export const winbizFactureSuccess = (payload) => ({
	type: WINBIZ_FACTURE_SUCCESS,
	payload,
})
export const winbizFactureError = (error) => ({
	type: WINBIZ_FACTURE_ERROR,
	payload: error,
})
export const winbizFactureReset = () => ({ type: WINBIZ_FACTURE_RESET })

export function createWinbizFacture(transactionId) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(winbizFactureBegin())
		return fetch(`${URL}api/winbiz/facture`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ transaction_id: transactionId }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(winbizFactureSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, winbizFactureError))
	}
}

export function declareWinbizManuel(transactionId, numero) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(winbizFactureBegin())
		return fetch(`${URL}api/winbiz/manuel`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ transaction_id: transactionId, numero }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(winbizFactureSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, winbizFactureError))
	}
}
